import getOnlyNumber from '../getOnlyNumber';

function formatSuffix(suffix?: string) {
  if (!suffix) return '';
  return ' ' + suffix;
}

/**
 * 콤마를 이용해 금액을 표기한 값을 반환합니다.
 * @param value
 * @param formatMinus
 * @param dashOnZero
 * @param suffix
 * @returns
 */

const addBlank = (value: string) => {
  return value.padEnd(value.length + 1, ' '); // 양수 뒤에 2칸 공백 추가
};

export default function formatMoney(
  value?: string | number,
  formatMinus?: boolean,
  dashOnZero?: boolean,
  suffix?: string,
  handleDecimalPoint: (value: number) => number = Math.floor,
) {
  if (value === undefined) {
    return '-';
  }
  const valueValue = typeof value === 'string' ? Number(getOnlyNumber(value)) : value;

  const str = handleDecimalPoint(valueValue).toLocaleString() + formatSuffix(suffix);

  const minusFormattedValue = formatMinus
    ? minusToBrackets(handleDecimalPoint(valueValue).toLocaleString(), suffix)
    : str;

  return dashOnZero && valueValue === 0 ? '-' : minusFormattedValue;
}

/**
 *
 * @param value
 * @param suffix
 * @returns
 */
export const minusToBrackets = (value: string, suffix = '') => {
  if (!value.includes('-')) return addBlank(value + formatSuffix(suffix));
  return value.replace(/^-/, '(').replace(/$/, `${formatSuffix(suffix)})`);
};
